import React from 'react';
import { Filter, SelectInput, ReferenceInput, List, Datagrid, TextField, ReferenceField, BooleanField } from 'react-admin';
import ScreenDescription from '../ScreenDescription';

const SourceFilters = (props) => (
  <Filter {...props}>
    <ReferenceInput label="Bloco" source="block_id" reference="whatsapp_block" alwaysOn allowEmpty>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput label="Tipo" source="message_type_id" reference="whatsapp_message_type" alwaysOn allowEmpty>
      <SelectInput optionText="name" />
    </ReferenceInput>
    <SelectInput
      label="Kind"
      source="kind"
      alwaysOn
      allowEmpty
      choices={[
        { id: 'template', name: 'Template' },
        { id: 'free_form', name: 'Mensagem livre' },
      ]}
    />
  </Filter>
);

// Granular: um registro por template individual ou por fluxo de mensagem
// livre. Reclassificar aqui (mudar bloco/tipo) vale pra todo o histórico
// daquela fonte, sem editar mensagem a mensagem.
const SourceList = props => (
  <>
    <ScreenDescription>
      Cada template aprovado na Twilio ou fluxo de mensagem livre vira uma "fonte" aqui — é onde bloco e tipo ficam salvos de
      verdade (nunca na mensagem individual). Reclassificar uma fonte (clicando nela) atualiza automaticamente todo o histórico
      de mensagens dela, passadas e futuras. Fontes novas nascem sozinhas no bloco "Outros" sem tipo, na primeira vez que são
      enviadas — não existe botão de criar aqui.
    </ScreenDescription>
    <List
      {...props}
      filters={<SourceFilters />}
      sort={{ field: 'name', order: 'ASC' }}
      bulkActionButtons={false}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" label="Nome" />
        <TextField source="kind" label="Kind" />
        <ReferenceField source="blockId" reference="whatsapp_block" label="Bloco" link={false}>
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="messageTypeId" reference="whatsapp_message_type" label="Tipo" link={false} allowEmpty>
          <TextField source="name" />
        </ReferenceField>
        <BooleanField source="active" label="Ativo" />
      </Datagrid>
    </List>
  </>
);

export default SourceList;
